import { useContext } from 'react'
import { TmapLogContext } from '@/providers'


export function useTmapLogContext() {
  return useContext(TmapLogContext)
}
